import styled from "@emotion/styled";

import { LoaderCircle, LoaderCircleThickness } from "./LoaderCircle";

interface IProps {
  size?: LoaderSize;
  inline?: boolean;
}

export enum LoaderSize {
  Small = 16,
  Medium = 70,
}

interface IContainerProps {
  size?: number;
  inline?: boolean;
}

const Container = styled.div<IContainerProps>`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.inline ? "display: inline-block;" : "margin: 0 auto 24px;")
  };
  width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.size
  }px;
  height: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.size
  }px;
`;

const sizeToThicknessMap = {
  [LoaderSize.Small]: LoaderCircleThickness.Thin,
  [LoaderSize.Medium]: LoaderCircleThickness.Thick,
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const Loader = ({ size = LoaderSize.Medium, inline }: IProps) => (
  <Container size={size} inline={inline}>
    <LoaderCircle thickness={sizeToThicknessMap[size]} />
  </Container>
);
